<template>
    <LongitudinalPeakAnalysis :sessions="sessions" :rainbowData="rainbowData"
        :rainbowComparisonData="rainbowComparisonData" :peakEpochCountData="peakEpochCountData"
        :peakEpochCountComparisonData="peakEpochCountComparisonData">
        <template #shared-info>
            <li> Comparison data consists of previous All Competitions matches with at least 85 minutes
                of match time.</li>
            <li> A player requires at least 4 full matches to have comparison data.</li>
        </template>
        <template #rainbow-legend>
            <LongitudinalChartLegend class="w-100 w-lg-25 mx-auto" :includeRollingAverage="false" :includeTarget="false"
                :displayComparisonKeys="false" />
        </template>
        <template #peak-counts-legend>
            <LongitudinalChartLegend :includeRollingAverage="false" :includeTarget="true" />
        </template>
    </LongitudinalPeakAnalysis>
</template>
<script>

export default {
    props: {
        sessions: Array,
        rainbowData: Object,
        rainbowComparisonData: Object,
        peakEpochCountData: Object,
        peakEpochCountComparisonData: Object,
    },
};
</script>
